class BenefitGroupChangedLocationPayload {
  constructor(systemNotificationPayloadData = {}) {
    this.benefit_group_name = systemNotificationPayloadData.benefit_group_name || "";
    this.id = systemNotificationPayloadData.id || "";
    this.name =
      systemNotificationPayloadData.name || "";
  }
}

export default BenefitGroupChangedLocationPayload;
